'use es6';

import { createAction } from 'redux-actions';
import { fetchSettings as fetchSettingsFromApi } from 'FormsUI/api/Leadin';
export const fetchSettingsRequest = createAction('leadin/FETCH_SETTINGS_REQUEST');
export const fetchSettingsResponse = createAction('leadin/FETCH_SETTINGS_RESPONSE');
export const fetchSettings = () => dispatch => {
  dispatch(fetchSettingsRequest());
  return fetchSettingsFromApi().then(response => dispatch(fetchSettingsResponse(response)), error => dispatch(fetchSettingsResponse(error)));
};